import React from 'react';
import { observer } from 'mobx-react';
import TreeCanvas from './TreeCanvas';
const TreePanel = observer(function ({ model }) {
    const { treeAreaWidth } = model;
    return (React.createElement("div", { style: { flexShrink: 0, width: treeAreaWidth } },
        React.createElement(TreeCanvas, { model: model })));
});
export default TreePanel;
//# sourceMappingURL=index.js.map